export default __webpack_public_path__ + "static/media/ic_info.728c3515.svg";